import React, { useState } from "react";
import Button from "../../shared/Button";
import api from "../../../lib/PinchMeAPI";
import ReCAPTCHA from "react-google-recaptcha";

import { grow } from "../../shared/helpers";
import ViewMore from "../../shared/ViewMore/ViewMore";

function Contact() {
  const pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  const captcha_key = process.env.PUBLIC_CAPTCHA_API_KEY;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [note, setNote] = useState("");
  const [disableButton, setDisableButton] = useState(true);

  const [emailErrors, setEmailErrors] = useState(null);
  const [nameErrors, setNameErrors] = useState(null);
  const [companyErrors, setCompanyErrors] = useState(null);
  const [noteErrors, setNoteErrors] = useState(null);

  let handleChange = ev => {
    let { name, value } = ev.currentTarget;
    switch (name) {
      case "name":
        setName(value);
        setNameErrors(null);
        break;
      case "email":
        setEmail(value);
        setEmailErrors(null);
        break;
      case "company":
        setCompany(value);
        setCompanyErrors(null);
        break;
      case "note":
        setNote(value);
        setNoteErrors(null);
        break;
    }
  };

  let handleErrors = (email, name, company, note) => {
    let isValid = true;

    if (pattern.test(email)) {
      setEmailErrors(null);
    } else {
      isValid = false;
      setEmailErrors("Please enter a valid email");
    }

    if (name) {
      setNameErrors(null);
    } else {
      isValid = false;
      setNameErrors("Please enter your name");
    }

    if (company) {
      setCompanyErrors(null);
    } else {
      isValid = false;
      setCompanyErrors("Please enter your comapny name");
    }

    if (note) {
      setNoteErrors(null);
    } else {
      isValid = false;
      setNoteErrors("Please enter your notes");
    }

    return isValid;
  };

  let submitInquiry = async () => {
    try {
      let response = await api.submitInquiry(company, name, email, note);
    } catch (error) {
      console.error(error);
    }
  };

  let handleFormSubmit = async ev => {
    ev.preventDefault();
    setDisableButton(true);

    if (handleErrors(email, name, company, note)) {
      submitInquiry();
      resetForm();
    }
  };

  let resetForm = () => {
    setEmail("");
    setName("");
    setNote("");
    setCompany("");
    grecaptcha.reset();
  };

  let handleCaptchaSubmit = async value => {
    try {
      let response = await api.submitCaptchaValidator(value);

      if (response.success === true) {
        setDisableButton(false);
      } else {
        console.error(response.success);
        setDisableButton(true);
      }
    } catch (error) {
      setDisableButton(true);
      console.error(error);
    }
  };

  return (
    <div className="pw-contact-container">
      <div className="pw-contact-container--inner pw-container">
        <h1 className="pw-contact-container--header">
          Interested in working with us too?
        </h1>
        <ViewMore
          onClick={() => $(".pw-contact-form-wrapper").slideToggle()}
          className="pw-contact-container--section-more"
          text="Read"
        />
        <div className="pw-contact-form-wrapper">
          <h1 className="pw-contact-container--title">
            Send us a note if you’re interested in learning about our
            data-driven <br />
            sampling, ratings & reviews, or consumer research programs.
          </h1>
          <form name="contact-form">
            <div className="pw-contact-container--form-block">
              <input
                name={"name"}
                id={"name"}
                placeholder="Name"
                className=""
                type="text"
                onChange={handleChange}
                value={name}
              />
              <small>{nameErrors}</small>
              <input
                name={"email"}
                id={"email"}
                placeholder="Enter your email"
                className=""
                type="text"
                onChange={handleChange}
                value={email}
              />
              <small>{emailErrors}</small>
              <input
                name={"company"}
                id={"company"}
                placeholder="Company"
                className=""
                type="text"
                onChange={handleChange}
                value={company}
              />
              <small>{companyErrors}</small>
              <input
                name={"note"}
                id={"note"}
                placeholder="Note"
                className=""
                type="text"
                onChange={handleChange}
                value={note}
              />
              <small>{noteErrors}</small>
            </div>
            <ReCAPTCHA
              sitekey={captcha_key}
              onChange={handleCaptchaSubmit}
              className={"captcha"}
            />
            <Button
              onClick={event => handleFormSubmit(event)}
              minWidth="190"
              label="LET'S DO THIS"
              type="contact"
              disabled={disableButton}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
